import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import PublicLayout from "web/components/PublicLayout";
import Layout from "web/components/Layout";

import ChangingTechnology from "web/pages/public/landing-page/HowItWork/ChangingTechnology";
import PowerfullTool from "web/pages/public/landing-page/HowItWork/PowerfullTool";
import PlansAndPricing from "web/pages/public/landing-page/HowItWork/PlansAndPricing";
import HowItWorksUrls from "web/pages/public/landing-page/HowItWork/HowItWorkUrls";
import LandingFooter from "web/pages/public/landing-page/LandingFooter";

const HowItWork = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet title="E-commerce Marketplace to Help You Manage Your Pallet Supply | PalletTrader">
      <meta name="description"
    content="PalletTrader is a powerful and easy tool to manage your pallet supply from any desktop or mobile device anytime and anywhere. Check our user-friendly plans and pricing."/>
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/how-it-works" />
      </Helmet>
      {localStorage.getItem("token") ?  <Layout transparentHeader={false} topBarViewMobile={"hide"}>
        <ChangingTechnology />
        <HowItWorksUrls />
        <PowerfullTool />       
        <PlansAndPricing />
        {/* <LandingFooter /> */}
      </Layout> :  <PublicLayout transparentHeader={true}>
        <ChangingTechnology />
        <HowItWorksUrls />
        <PowerfullTool />
        <PlansAndPricing />
        <LandingFooter />
      </PublicLayout>}


    </>
  );
};

export default HowItWork;
